var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 10.5C13 10.6076 12.9771 10.712 12.9313 10.8132C12.8855 10.9143 12.8244 10.9983 12.7481 11.065L8.53435 14.778C8.36641 14.926 8.15267 15 7.89313 15C7.63359 15 7.41985 14.926 7.25191 14.778C7.08397 14.63 7 14.4417 7 14.213C7 13.9843 7.08397 13.796 7.25191 13.648L10.8244 10.5L7.25191 7.35202C7.08397 7.20404 7 7.0157 7 6.787C7 6.5583 7.08397 6.36996 7.25191 6.22197C7.41985 6.07399 7.63359 6 7.89313 6C8.15267 6 8.36641 6.07399 8.53435 6.22197L12.7481 9.93498C12.8397 10.0157 12.9047 10.1031 12.9432 10.1973C12.9817 10.2915 13.0006 10.3924 13 10.5Z",
    fill: "#011367"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiRightArrow);
export default __webpack_public_path__ + "static/media/ai-right-arrow.d5c6d04b4c7f6f53c72a1ef21145fe3a.svg";
export { ForwardRef as ReactComponent };